import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class NewsPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.newsRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.newsImport,
    );
    this.newsAutocomplete = permissionChecker.match(
      Permissions.values.newsAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.newsCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.newsEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.newsDestroy,
    );
  }
}
